import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
//import * as THREE from 'three';
@Component({
  selector: 'three-demo',
  templateUrl: './three-demo.component.html',
    styleUrls: ['./three-demo.component.scss']
})
export class ThreeDemoComponent implements OnInit {
  @ViewChild('rendererContainer', { static: true }) rendererContainer: ElementRef;


  // renderer = new THREE.WebGLRenderer();
  // scene = null;
  // camera = null;
  // cubeMesh = null;
  // materials = null;

   constructor() {
  //     // SCENE.
  //     this.scene = new THREE.Scene();

  //     //CAMERA
  //     this.camera = new THREE.PerspectiveCamera(75, 600 / 400, 1, 10000);
  //     this.camera.position.z = 1000;

  //     // LIGHT
  //     var light = new THREE.DirectionalLight( 0xffffff );
  //     light.position.set( 0, 1, 1 ).normalize();
  //     this.scene.add(light);

  //     var ambient = new THREE.AmbientLight ( 0x555555 );
  //     this.scene.add(ambient);

  //     // UTILITY STUFF...
  //     this.createRubixMaterial();

  //     // GEOMETRY
  //     const geometry = new THREE.BoxGeometry(400, 400, 400);
  //     //var meshFaceMaterial = new THREE.MeshFaceMaterial( this.materials );
  //     this.cubeMesh = new THREE.Mesh(geometry, this.materials);

  //     this.scene.add(this.cubeMesh);
      
   }

   ngOnInit() {
    
  //   this.renderer.render(this.scene, this.camera);
    
   }


  // createRubixMaterial() {
    
  //   //var material1 = new THREE.MeshBasicMaterial( { color: '#433F81' } );
  //   //var material2 = new THREE.MeshBasicMaterial( { color: '#ffffff' } );
  //   //var material3 = new THREE.MeshBasicMaterial( { color: '#00ff00' } );
  //   //var material4 = new THREE.MeshBasicMaterial( { color: '#ff0000' } );
    
  //   //var material5 = new THREE.MeshBasicMaterial( { color: '#0000ff' } );
  //   /*
  //   var material6 = new THREE.MeshBasicMaterial( { color: '#0000ff' } );
  //   */
    
  //   var t1 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/1.jpg');
  //   var material1 = new THREE.MeshBasicMaterial({map : t1} );
    
  //   var t2 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/2.jpg');
  //   var material2 = new THREE.MeshBasicMaterial({map : t2} );
    
  //   var t3 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/3.jpg');
  //   var material3 = new THREE.MeshBasicMaterial({map : t3} );
    
  //   var t4 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/4.jpg');
  //   var material4 = new THREE.MeshBasicMaterial({map : t4} );
    
  //   var t5 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/5.jpg');
  //   var material5 = new THREE.MeshBasicMaterial({map : t5} );

  //   var t6 = new THREE.TextureLoader().load('../../../../../../assets/threeTextures/6.jpg');
  //   var material6 = new THREE.MeshBasicMaterial({map : t6} );

    
  //   //var material1 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/1.jpg') } );
  //   //var material2 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/2.jpg') } );
  //   //var material3 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/3.jpg') } );
  //   //var material4 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/4.jpg') } );
  //   //var material5 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/5.jpg') } );
  //   //material6 = new THREE.MeshPhongMaterial( { map: THREE.ImageUtils.loadTexture('../../../../../../assets/6.jpg') } );
    
  //   //var texture = new THREE.TextureLoader().load( '../../../../../../assets/1.jpg');
  //   //var material1 = new THREE.MeshPhongMaterial(texture);
  //   //var material1 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/1.jpg') } );
  //   // var material2 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/2.jpg') } );
  //   // var material3 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/3.jpg') } );
  //   // var material4 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/4.jpg') } );
  //   // var material5 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/5.jpg') } );
  //   // material6 = new THREE.MeshPhongMaterial( { map: THREE.TextureLoader().load('../../../../../../assets/6.jpg') } );
    
  //   this.materials = [material1, material2, material3, material4, material5, material6];
  // }

  // ngAfterViewInit() {
  //     this.renderer.setSize(600, 400);
  //     this.renderer.domElement.style.display = 'block';
  //     this.renderer.domElement.style.margin = 'auto';
  //     this.rendererContainer.nativeElement.appendChild(this.renderer.domElement);

  //     this.animate();
  // }

  // animate() {
  //   window.requestAnimationFrame(() => this.animate());
  //     this.cubeMesh.rotation.x += 0.01;
  //     this.cubeMesh.rotation.y += 0.02;
  //     this.renderer.render(this.scene, this.camera);
  // }

}

 
